module.exports = __webpack_public_path__ + "img/axe.5daac000.png";